import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const Container = ({ children }: any) => {
  const darkMode = useSelector((state: RootState) => state.darkMode.value);
  if (darkMode)
    document.querySelector("html")!.style.background = "#0B1120";
  else document.querySelector("html")!.style.backgroundColor = "white";
  return <div className={darkMode ? "dark" : "light"}>{children}</div>;
};

export default Container;
